import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-selection',
  templateUrl: './filter-selection.component.html',
  styleUrls: ['./filter-selection.component.scss'],
  standalone: false
})
export class FilterSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
